let SFDomain = 'cs73.salesforce.com';

if (process.env.REACT_APP_ENV === 'prod') {
  SFDomain = 'jaic-g.my.salesforce.com';
}

export default {
  SFDomain: SFDomain,
};
